(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-configure-more-btn]');
    if (!btn) return;
    if (window.location.pathname === '/pages/konfigurator') {
      e.preventDefault();
      window.dispatchEvent(new CustomEvent('configurator-app-reset'));
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.hide === 'function') drawer.hide();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
